import { Badge } from '@neo/primitives/badge'
import { TruncatedTextWithTooltip } from '@neo/primitives/truncated-text-with-tooltip'
import type { NodeComponent } from '../config/panel.config'
import { FlowNodeDescriptions } from '../constants'

export const PanelItem = ({
  node,
  createNodeFromMenu,
  icon,
  iconClass,
}: {
  node: NodeComponent
  icon: React.ReactNode
  iconClass: string
  createNodeFromMenu: (node: NodeComponent) => void
}) => (
  <button
    type="button"
    key={node.id}
    className="flex w-full items-start gap-2 rounded-md text-p-400 hover:bg-muted justify-start py-1.5 px-2"
    onClick={(e) => {
      e.stopPropagation()
      createNodeFromMenu(node)
    }}
  >
    <div className="flex items-start gap-2 w-full">
      {/* h-[22px] = the label's line-height, so the glyph sits on that line */}
      <div className={`flex h-[22px] shrink-0 items-center ${iconClass}`}>{icon}</div>
      <div className="flex flex-col items-start justify-start w-full">
        <div className="flex w-full min-w-0 items-center gap-1.5">
          <TruncatedTextWithTooltip className="truncate w-full text-left text-p-500">
            {node.label}
          </TruncatedTextWithTooltip>
          {node.badge && (
            <Badge
              variant="default"
              className="shrink-0 px-1.5 py-0 text-tertiary text-xs-600 leading-4"
            >
              {node.badge}
            </Badge>
          )}
        </div>
        <div className="text-xs-400 text-secondary text-left w-full">
          {FlowNodeDescriptions[node.meta.node_type]}
        </div>
      </div>
    </div>
  </button>
)
